function dateNow() {
  return /*           */ new Date();
}
function getTime() {
  return dateNow().getTime();
}
function timeNow() {
  return dateNow().toLocaleTimeString(void 0, {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    fractionalSecondDigits: 3
  });
}
function now() {
  return Date.now();
}
export {
  dateNow,
  getTime,
  now,
  timeNow
};
